import _ from 'lodash';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const addElementByField = (list, field, value) => {
  const newList = [...list];
  const index = _.findIndex(newList, function(element) {
    return (
      element[field] && element[field].trim().toUpperCase() === value.trim().toUpperCase()
    );
  });
  if (index >= 0) {
    return list;
  }
  const newObj = {
    [field]: value,
  };
  newList.push(newObj);
  return newList;
};

const INITIAL_STATE_WARRANTIES_LIST = {
  'list': [],
  'loading': false,
};

export const warrantiesAdminList = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_LIST, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTIES_ADMIN]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

const INITIAL_STATE_WARRANTY_ADMIN = {
  'warranty': null,
  'loading': false,
  'loadingStatus': false,
  'loadingCondition': false,
  'loadingCause': false,
  'loadingRepair': false,
  'warrantyStatus': [],
  'conditionList': [],
  'causeList': [],
  'repairList': [],
};

export const warrantyAdmin = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_ADMIN, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_BY_ID_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
    [ActionTypes.CLEAR_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
    [ActionTypes.FETCHING_WARRANTY_ADMIN_STATUS]: (state, action) => ({
      ...state,
      'loadingStatus': true,
      'warrantyStatus': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_ADMIN_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'warrantyStatus': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_ADMIN_STATUS]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'warrantyStatus': action.response.data,
    }),
    [ActionTypes.ADD_CONDITION_WARRANTY_ADMIN]: (state, action) => {
      const newList = addElementByField(
        state.conditionList,
        'conditionEn',
        action.payload
      );
      return {
        ...state,
        'conditionList': newList,
      };
    },
    [ActionTypes.FETCHING_CONDITION_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingCondition': true,
      'conditionList': [],
    }),
    [ActionTypes.FETCHED_CONDITION_LIST_WARRANTY_ADMIN_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingCondition': false,
      'conditionList': [],
    }),
    [ActionTypes.FETCHED_CONDITION_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingCondition': false,
      'conditionList': action.response.data,
    }),
    [ActionTypes.ADD_CAUSE_WARRANTY_ADMIN]: (state, action) => {
      const newList = addElementByField(
        state.causeList,
        'causeEn',
        action.payload
      );
      return {
        ...state,
        'causeList': newList,
      };
    },
    [ActionTypes.FETCHING_CAUSE_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingCause': true,
      'causeList': [],
    }),
    [ActionTypes.FETCHED_CAUSE_LIST_WARRANTY_ADMIN_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingCause': false,
      'causeList': [],
    }),
    [ActionTypes.FETCHED_CAUSE_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingCause': false,
      'causeList': action.response.data,
    }),
    [ActionTypes.ADD_REPAIR_WARRANTY_ADMIN]: (state, action) => {
      const newList = addElementByField(
        state.repairList,
        'repairEn',
        action.payload
      );
      return {
        ...state,
        'repairList': newList,
      };
    },
    [ActionTypes.FETCHING_REPAIR_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingRepair': true,
      'repairList': [],
    }),
    [ActionTypes.FETCHED_REPAIR_LIST_WARRANTY_ADMIN_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingRepair': false,
      'repairList': [],
    }),
    [ActionTypes.FETCHED_REPAIR_LIST_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loadingRepair': false,
      'repairList': action.response.data,
    }),
  })(state, action);
};

const INITIAL_STATE_WARRANTY_CHASSIS = {
  'vehicle': {},
  'loading': false,
};

export const warrantyAdminVehicle = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_CHASSIS, {
    [ActionTypes.FETCHING_TWC_WARRANTY_ADMIN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_CHASSIS_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'vehicle': null,
    }),
    [ActionTypes.CLEAR_WARRANTY_ADMIN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': {},
    }),
  })(state, action);
};
